import * as angular from 'angular';
import {IController, ILogService} from "angular";
import {Address} from "../../../addresses/models/address.model";

export class SubTaskActionsTableRowCtrl implements IController {
  action: any;

  public showAttachmentMetadataTooltip: boolean = false

  $onInit() {
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('subTaskActionsTableRow', {
    bindings: {
      action: '<'
    },
    template: require('./sub-task-actions-table-row.html').default,
    controller: SubTaskActionsTableRowCtrl
  });
